import { Navigation } from "./Navigation";
import { Footer } from "./Footer";
import { NewsletterPopup } from "./NewsletterPopup";

interface LayoutProps {
  children: React.ReactNode;
}

export const Layout = ({ children }: LayoutProps) => {
  return (
    <div className="min-h-screen flex flex-col">
      <Navigation />
      <main className="flex-1">
        {children}
      </main>
      <Footer />
      <NewsletterPopup />
    </div>
  );
};